module.exports = {"meta":{"ajaxType":"post","path":"/wantwant-server/kadrfsalestore/list","type":"report","id":"sales_list","code":"sales_list","title":"KA大润发销售门店表","buttons":[],"columns":[{"name":"accountId","title":"账户ID"},{"name":"downloadTime","title":"数据采集时间"},{"name":"id","title":"主键ID"},{"name":"prodAmount","title":"日销售含税总金额"},{"name":"storeName","title":"系统门店名称"},{"name":"updatedTime","title":"修改日期"}],"params":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/views/sales/kadrfsalestore.json
// module id = uw90
// module chunks = 63